{
  window.setGridHeight = (selector) => {
    let gridOffsets = [];
    let gridRowOffsets = []

    gridOffsets = Array.from(document.querySelectorAll(selector)).map((element,index) => {
      let grid = element.closest('.grid__item') || element.closest('[data-equal]');
      element.removeAttribute('style');
      return {
        selector:element,
        selectorHeight: element.offsetHeight,
        offsetTop: grid.offsetTop,
      }
    });

    let offsets = gridOffsets.map(element => element.offsetTop);
    gridRowOffsets = [...new Set(offsets)];

    gridRowOffsets.forEach(rowOffset => {
      let rowGrids = gridOffsets.filter(grid => (grid.offsetTop == rowOffset));
      let comanElementHeight = Math.max.apply(Math,(rowGrids.map(ele => ele.selectorHeight)));
      rowGrids.forEach(grid => {
        grid.selector.style.minHeight = comanElementHeight+'px';
      });
    });
  }

 setTimeout(() => {
    matchHeightCallback();
  }, 2000)
  
  window.addEventListener('resize', function(event){
    matchHeightCallback();
  });

  let matchHeightCallback = () => {
    window.setGridHeight('.js-title-height'); 
  }
  matchHeightCallback();
}

setTimeout(() => {
  const slider = document.querySelector('#navbar-container ul');
  if(!slider) return;
  let isDown = false;
  let startX;
  let scrollLeft;
  
  // Mouse Down Event
  slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      slider.style.cursor = 'grabbing';
  });
  
  // Mouse Leave Event
  slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.style.cursor = 'grab';
  });
  
  // Mouse Up Event
  slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.style.cursor = 'grab';
  });
  
  // Mouse Move Event
  slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // Multiply by 2 for faster scroll
      slider.scrollLeft = scrollLeft - walk;
  });
}, 1000);

// Checkout button pre order conditions
let conditionsCheckoutCheckbox = document.getElementById('checkout-conditions-checkbox');
if(conditionsCheckoutCheckbox) {
  let checkoutButton = document.querySelector('.loop-checkout-button');
  if (checkoutButton) checkoutButton.disabled = true;
  conditionsCheckoutCheckbox.addEventListener('change', function() {
    if (checkoutButton) checkoutButton.disabled = !this.checked;
  });
}

// Product Page Size Dropdown
{
  let variantOptions = document.querySelectorAll('.js-product-variant');
  if (variantOptions.length > 0) {
    variantOptions.forEach((item) => {
      item.addEventListener('click', () => {
        if(item.closest('details')) item.closest('details').removeAttribute('open');
        let sizeTitle = item.querySelector('.js-size-title');
        let dropdownValue = document.querySelector('.js-variant-dropdown-value');
        if (dropdownValue) dropdownValue.textContent = sizeTitle.textContent;
      })
    })
  }
}
const triggerBtn = document.querySelector('.trigger');
const modal = document.querySelector('.modal');
const closeBtn = document.querySelector('.close-button');

if(triggerBtn){
triggerBtn.addEventListener('click', () => {
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden'; 
});
}

// Close modal on X
if(closeBtn){
closeBtn.addEventListener('click', () => {
  modal.style.display = 'none';
  document.body.style.overflow = '';
});
}

// Close modal on click outside content
window.addEventListener('click', (e) => {
  if(e.target === modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
});